// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { withStyles } from '@material-ui/core';
import uuidv4 from 'uuid/v4';

import { statuses } from '../../../../../../../../config/types';
import RejectionCell from '../RejectionCell/RejectionCell';
import MainRightInfo from '../MainRightInfo/MainRightInfo';
import MainLeftInfo from '../MainLeftInfo/MainLeftInfo';
import statusInProgress from '../../../../../../../../images/status-in-progress.png';
import statusRejected from '../../../../../../../../images/status-rejected.png';
import statusAccepted from '../../../../../../../../images/status-ok.png';
import styles from './styles.js';

const statusApplied = [7, 13, 15];

class OrderFullDesktop extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    order: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    order: {},
  };

  renderTop = () => {
    const { classes, order } = this.props;
    let statusId = 0;
    Object.keys(statuses).map((key) => {
      if (statuses[key] === order.OrderStatus) {
        statusId = key;
      }
      return null;
    });
    statusId = parseInt(statusId, 10);
    const background = statusApplied.includes(statusId) ? classes.paid : classes.processing;
    return (
      <div className={classNames(classes.topContainer, background)}>
        <span className={classes.orderIdText}>{`ORDER ID: ${order.OrderID}`}</span>
        <div className={classes.dateTimeContainer}>
          <span>{order.CreatedOn}</span>
        </div>
      </div>
    );
  }

  renderMobileTable = () => {
    const { classes, order } = this.props;
    const title = 'Title of The Item';
    const barcode = 'Barcode';
    const price = 'Sellitback Price';
    const scanned = 'Scanned On';
    const status = 'Status';
    const reject = 'Rejection Info';

    return (
      <div>
        {order.OrderDetails.map((row, index) => (
          <div
            key={uuidv4()}
            className={classNames(classes.tableRowContainer,
              order.OrderDetails.length - 1 !== index ? classes.borderBottom : null)}
          >
            <span className={classes.rowTitle}>{title}</span>
            <span className={classes.rowDescription}>{row.Title}</span>
            <span className={classes.rowTitle}>{barcode}</span>
            <span className={classes.rowDescription}>{row.EAN}</span>
            <span className={classes.rowTitle}>{price}</span>
            <span className={classes.rowDescription}>{row.SellbackPrice.toFixed(2)}</span>
            <span className={classes.rowTitle}>{scanned}</span>
            <span className={classes.rowDescription}>
              {row.ScannedOn ? 'scanned' : 'not scanned'}
            </span>
            <span className={classes.rowTitle}>{status}</span>
            <div>
              <img
                className={classes.statusImage}
                src={row.Accepted === 1
                  ? statusAccepted
                  : (row.Accepted === -1
                    ? statusRejected
                    : statusInProgress)}
                alt={'status'}
              />
            </div>
            {row.Accepted === -1 && <span className={classes.rowTitle}>{reject}</span>}
            {row.Accepted === -1 && (
              <span className={classes.rowDescription}>
                <RejectionCell
                  RejectionReason={row.RejectionReason}
                  ImageURL={row.ImageURL}
                  OrderDetailsID={row.OrderDetailsID}
                />
              </span>)}
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { classes, order } = this.props;

    return (
      <div className={classes.mainContainer}>
        {this.renderTop()}
        <div className={classes.contentContainer}>
          <MainRightInfo order={order} />
          <MainLeftInfo order={order} />
          <div className={classes.line} />
          {this.renderMobileTable()}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(OrderFullDesktop);
